import { feedbackV2, feedback } from '@ecosystem/newron-design-system';

const { ActionType, AlertSize } = feedback;
type Notification = 'success' | 'error' | 'warn' | 'info';

export const WithAlert = ({
  title,
  type = 'warn',
  actionType = ActionType.DISMISSIBLE,
  size = AlertSize.DEFAULT,
  ...otherProps
}: {
  title: React.ReactNode | string;
  type?: Notification;
  actionType?: (typeof ActionType)[keyof typeof ActionType];
  size?: (typeof AlertSize)[keyof typeof AlertSize];
  [otherProps: string]: any;
}) => {
  const { Alert } = feedbackV2;
  return (
    <div>
      <Alert title={title} type={type} actionType={actionType} size={size} isActionable={true} {...otherProps}></Alert>
    </div>
  );
};
